/* eslint-disable */
<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-layout>
          <v-flex xs12 md12)>
            <v-card>

              <v-container id="scroll-target" fluid class="pa-0  mt-2">
                <v-layout wrap>
                  <v-flex xs2 md1>
                    <div class="subhead"> Input:</div>

                  </v-flex>


                  <v-flex xs2 md1>
                    <div class="subhead">
                      <v-tooltip bottom>
                        <v-btn depressed small @click="generateSample" slot="activator">Generate</v-btn>
                        <span>Sample some sentences randomly</span></v-tooltip>
                    </div>
                  </v-flex>
                  <v-flex xs3 md1>

                  </v-flex>
                  <v-flex xs3 md1>

                  </v-flex>
                  <v-flex xs12 style="height: 520px">
                    <v-divider></v-divider>
                    <v-text-field
                      rows="20"
                      label="Sentences or Paragraphs"
                      v-model="inputText"
                      full-width
                      multi-line
                      single-line
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12 md12>
            <v-card>

              <v-container fluid class="pa-0 mt-2 " style="">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-container class="pa-0 ">
                      <v-layout class="subhead">
                        Prediction:
                      </v-layout>
                    </v-container>
                  </v-flex>

                  <v-flex xs6>
                    <v-container class="pa-0" fluid>
                      <v-layout row justify-space-between>

                        <v-flex>
                        </v-flex>

                        <v-flex style="text-align: right" class="ma-1 mr-2">
                          <v-btn-toggle class="mt-1" v-model="display_style">
                            <v-tooltip bottom>
                              <v-btn flat @click="display_inline" slot="activator">
                                inline
                              </v-btn>
                              <span>Display sentences inline</span></v-tooltip>

                            <v-tooltip bottom>
                              <v-btn flat @click="display_list" slot="activator">
                                list
                              </v-btn>
                              <span>Display sentences as lsit</span></v-tooltip>

                          </v-btn-toggle><!--
                        <v-subheader class="pa-0" style="text-align: right">

                        &lt;!&ndash; &ndash;&gt;
                        </v-subheader>-->
                        </v-flex>

                        <!--<v-flex xs3>
                          ffff
                          &lt;!&ndash;<v-subheader>dddd
                            &lt;!&ndash;<v-btn-toggle v-model="display_style">
                              <v-tooltip bottom>
                                <v-btn flat @click="display_inline" slot="activator">
                                  inline
                                </v-btn>
                                <span>Display sentences inline</span></v-tooltip>

                              <v-tooltip bottom>
                                <v-btn flat @click="display_list" slot="activator">
                                  list
                                </v-btn>
                                <span>Display sentences as lsit</span></v-tooltip>

                            </v-btn-toggle>&ndash;&gt;
                          </v-subheader>&ndash;&gt;
                        </v-flex>-->
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>

                  <v-flex xs12 style="height: 520px" class="scroll-y">
                    <v-divider></v-divider>
                    <div class="card__text">
                      <resultlist v-bind:result="result" v-bind:display_style="display_style"></resultlist>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>


    <v-layout row wrap justify-center>
      <v-flex justtify-center md1 xs1>
        <div class="text-xs-center">
          <v-btn
            :loading="isLoading"
            :disable="isLoading"
            top
            block
            round
            dark
            color="primary"
          >{{inputIndicator}}
          </v-btn>
        </div>

      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1 class="mt-4">
        <div>
          <p style="margin-bottom: 6px;">1. This tool predicts whether a sentence needs a citation.</p>
          <p style="margin-bottom: 6px;">2. The sentence which needs a citation will be highlighted and have a suffix "[...]". You can hover over the sentence to get the probabilities of needing a citation</p>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1 class="link-list">
        <div>
          <p style="margin-bottom: 6px;">Paper: <strong>Zeng, T., Acuna, D.E. (2020)</strong>, <a href="https://doi.org/10.1007/s11192-020-03421-9" target="_blank"><em>Modeling citation worthiness by using attention-based Bidirectional Long Short-Term Memory networks and interpretable models</em></a>, <strong>Scientometrics</strong></p>
          <p style="margin-bottom: 6px;">Datasets and code: <a href="https://github.com/sciosci/cite-worthiness" target="_blank"> https://github.com/sciosci/cite-worthiness</a> </p>
          <p style="margin-bottom: 6px;">The datasets and code are developed in the <a href="https://scienceofscience.org/" target="_blank">Science of Science and Computational Discovery Lab</a> </p>
        </div>
      </v-flex>
    </v-layout>

    <v-snackbar
      :timeout="parseInt('2500')"
      top
      multi-line
      vertical
      auto-height
      absolute
      v-model="snackbar"
    >
      <v-card-text v-html="snackMsg">

      </v-card-text>
      <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .subhead {
    height: 48px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    padding: 0 16px;
    color: rgba(0, 0, 0, .54);
  }
  .link-list {
    margin-top:12px;
    margin-bottom:50px;
    height: 72px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, .54);
    align: left;
  }
  .mt-5{
    margin-top: 30px;
  }
</style>


<script>
  import ResultList from '@/components/ResultList'

  var util = require('../util/util')

  console.log(util.debounce)

  export default {
    name: 'Index',
    data: () => ({
      isLoading: false,
      inputText: '',
      outputHtml: '',
      snackMsg: '',
      snackbar: false,
      display_style: 1,
      result: null,
      samples: ['A post hoc analysis was performed in all patients who started with NIV, from a previously published randomized controlled trial. Patients, who had been diagnosed with chronic respiratory failure due to a neuromuscular disorder (NMD) or a thoracic cage problem, were included.', 'The study was approved by the Medical Ethics Committee of the University of Groningen, University Medical Center of Groningen, and written informed consent was obtained from all patients. In line with our hypothesis and reassuringly, the results for gas exchange and QOL were not significantly different between patients who started in the hospital versus at home.', 'In the current analysis, we pooled all patients without ALS in one group and compared it to those with ALS.', 'The SRI contains seven domains covering: respiratory complaints, physical functioning, attendant symptoms and sleep, social relationship, anxiety, psychological well-being and social functioning.', 'Scores range between 0 and 100, with high sores representing better quality of life. The MRF-28 contains three domains: daily activities, cognitive function and invalidity; scores range from 0 (best) to 100 (worse). The SF-36 contains eight domains: physical functioning, role physical, bodily pain, general health, vitality, social functioning, role emotional and mental health completed with the physical and mental component summary score 0 (worse) to 100 (best). The HADS contains the anxiety and depression domain; scores range from 0 (best) tot 42 (worse).'],
      prevRandNum: 0,
      inputIsDirty: false
    }),
    created: function () {

    },
    computed: {
      inputIndicator: function () {
        if (this.isLoading) {
          return 'Fetching'
        } else if (this.inputIsDirty) {
          return '... Typing'
        } else {
          return 'Done'
        }
      }
    },
    watch: {
      inputText: function () {
        this.inputIsDirty = true
        this.handleInput()
      }
    },
    components: {
      resultlist: ResultList
    },
    methods: {
      handleInput: util.debounce(function () {
        this.submit()
      }, 500),
      getSentences: function () {
        var sentenceList = [{'id': 1, 'sentence': 'This is a sentence 1'},
          {'id': 2, 'sentence': 'This is a sentence 2'},
          {'id': 3, 'sentence': 'This is a sentence 6'}]
        return sentenceList
      },

      generateSample: function () {
        var self = this
        var samples = self.samples
        var len = samples.length
        var randomNum = Math.floor(Math.random() * (len))
        if (self.prevRandNum === randomNum) {
          self.generateSample()
          return
        }
        self.prevRandNum = randomNum
        self.inputText = samples[randomNum]
      },

      display_inline: function () {
        this.display_style = 0
      },

      display_list: function () {
        this.display_style = 1
      },

      submit: function () {
        var self = this
        var url = '/api/citation_needed/scoringtext'
        var data = self.inputText
        if (!data) {
          self.snackMsg = 'Please input sentences before submitting the form'
          self.snackbar = true
          return
        }
        /* eslint-disable */
        $.ajax({
          type: 'POST',
          url: url,
          data: (data),
          // type of data we are expecting in return:
          dataType: 'json',
          processData: false,
          contentType: 'application/json',
          success: function (data) {
            if (data.code === '0' && data.subCode === '0') {
              self.result = data.result
            } else {
              self.snackMsg = 'Prediction failed, please try again.'
              self.snackbar = true
            }
          },
          error: function (xhr, errorType, error) {
            self.snackMsg = 'Network Error: ' + errorType + (error ? (', ' + error) : '')
            self.snackbar = true
            console.log(xhr)
            console.log(errorType)
            console.log(error)
          },
          beforeSend: function (xhr, settings) {
            self.isLoading = true
          },
          complete: function (xhr, status) {
            self.isLoading = false
            self.inputIsDirty = false
          }
        })
      }
    },
    mounted: function () {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue